import React from 'react';
import { BusinessDetailProvider } from '@/context/BusinessDetailContext';
import { ProductWithBusinessProvider } from './components/Form/ProductWithBusinessContext';
import FormLev from './components/Form/Formlev';

const Levantamento = () => {
  return (
    <BusinessDetailProvider>  
      <div className='w-[100%] h-[100%] bg-indigo-200 overscroll-none'>
          {/** Formulário de Detalhes */}
          <div className='bg-white border-t-2 border-indigo-200'>
            <ProductWithBusinessProvider>
              <FormLev />
            </ProductWithBusinessProvider>
          </div>
      </div>
    </BusinessDetailProvider>
  );
};

export default Levantamento;
